import { HznDivider } from './divider/divider.js';
import { defineHorizonElement } from '@horizon/common/helpers';
import './types.js';
defineHorizonElement('hzn-divider', HznDivider);
//# sourceMappingURL=hzn-divider.js.map